import React from 'react';
import { Controller, Control } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import TextField from 'common/components/TextField';
import { NOTES } from '../../../../common/constants';
import { CheckoutValues } from 'store/ducks/checkout/types';

type Props = {
    checkoutValues: CheckoutValues;
    control: Control;
    errors: any;
};

const Notes: React.FC<Props> = ({ checkoutValues, control }) => {
    const { notes } = checkoutValues || {};

    return (
        <Grid item xs={12} md={5}>
            <Controller
                as={<TextField fullWidth />}
                control={control}
                defaultValue={notes || ''}
                label="Dodatkowe uwagi"
                name={NOTES}
                multiline
                rows={5}
                variant="outlined"
            />
        </Grid>
    );
};

export default Notes;
